import { render, staticRenderFns } from "./AboutView.vue?vue&type=template&id=79b20322&scoped=true"
import script from "./AboutView.vue?vue&type=script&lang=ts"
export * from "./AboutView.vue?vue&type=script&lang=ts"
import style0 from "./AboutView.vue?vue&type=style&index=0&id=79b20322&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b20322",
  null
  
)

export default component.exports